<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="far fa-address-card mr-4"></i>Contacts</span>
        </h1>
        <main class="overflow-x-hidden overflow-y-scroll flex-1" v-if="contacts">
            <template v-if="Object.keys(contacts).length">
                <div v-for="group in Object.keys(contacts)" :key="group" class="relative">
                    <div
                        class="z-10 sticky top-0 border-t border-b -mb-px border-gray-200 bg-gray-50 px-6 py-1 text-sm font-medium text-gray-500">
                        <h3>{{ group }}</h3>
                    </div>
                    <ul class="relative z-0">
                        <li v-for="contact in contacts[group]" :key="contact.key()" :id="'i-' + (contact.key())">
                            <div
                                class="px-6 pb-5 cursor-pointer border-t border-gray-200 hover:bg-gray-50"
                                tabindex="0"
                            >
                                <div class="flex items-end">
                            <span class="flex-1 mt-2.5 truncate">
                                <h2 class="text-sm font-medium text-brand" v-text="contact.name"></h2>
                                <p v-text="contact.position" class="mt-1 text-sm text-gray-500 truncate"></p>
                            </span>
                                    <span class="text-right flex-1 truncate mt-4">
                                <p class="ml-0 text-xs text-gray-500 truncate" v-text="contact.company"></p>
                                <p class="ml-0 text-xs text-gray-500 truncate" v-if="contact.phone">
                                    <i class="far fa-clone text-blue-400 opacity-25 pr-0.5 hover:opacity-100"
                                       @click="clipboard(contact.phone)"></i>
                                    <a :href="'tel:'+contact.phone" v-text="contact.phone"></a>
                                </p>
                                <p class="ml-0 text-xs text-gray-500 truncate" v-if="contact.email">
                                    <i class="far fa-clone text-blue-400 opacity-25 pr-0.5 hover:opacity-100"
                                       @click="clipboard(contact.email)"></i>
                                    <a :href="'mailto:'+contact.email" v-text="contact.email"></a>
                                </p>
                            </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
            <div class="place-content-center h-full w-full" v-else>
                <div class="flex flex-col text-gray-500">
                    <div class="w-full text-center font-bold text-md"><span></span>No Package Contacts
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import {Contact} from "@models";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            contacts: null
        }
    },
    computed: {},
    methods: {
        clipboard(text) {
            navigator.clipboard.writeText(text);
        },
    },
    async mounted() {
        let groupedContacts = {}
        let contacts = await Contact.forPackage(this.dashboardProps.legacyPackage.reference);
        contacts.forEach((c) => {
            if (!groupedContacts[c.type]) {
                groupedContacts[c.type] = [];
            }
            groupedContacts[c.type].push(c)
        })
        this.contacts = groupedContacts
    }
}

</script>